import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { usePageTitle } from '../hooks/usePageTitle';
import './Privacy.css';

function Privacy() {
  usePageTitle('Privacy Policy');
  const [content, setContent] = useState('');

  useEffect(() => {
    const defaultPrivacy = `Last Updated: ${new Date().toLocaleDateString()}

At Biltzentech, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy explains how we collect, use, and safeguard your data.

**Information We Collect**

We collect information that you provide directly to us, including:
- Name and contact information
- Company details
- Project requirements and inquiries
- Communication preferences

**How We Use Your Information**

We use the information we collect to:
- Respond to your inquiries and provide services
- Improve our products and services
- Send you relevant updates and communications
- Comply with legal obligations

**Data Security**

We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction.

**Your Rights**

You have the right to:
- Access your personal data
- Request correction of inaccurate data
- Request deletion of your data
- Opt-out of marketing communications

**Contact Us**

If you have questions about this Privacy Policy, please contact us at:
Email: contact@biltzentech.com
Phone: +91 9740736690`;
    supabase.from('site_content').select('content').eq('id', 'privacy_policy').single().then(({ data }) => {
      setContent(data?.content || defaultPrivacy);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="privacy">
      <section className="privacy-hero">
        <div className="privacy-container">
          <h1 className="privacy-hero-title">Privacy Policy</h1>
          <p className="privacy-hero-subtitle">Your privacy is important to us</p>
        </div>
      </section>

      <section className="privacy-main">
        <div className="privacy-container">
          <div className="privacy-content">
            {content.split('\n\n').map((paragraph, index) => {
              if (paragraph.startsWith('**') && paragraph.endsWith('**')) {
                return <h2 key={index}>{paragraph.replace(/\*\*/g, '')}</h2>;
              }
              return <p key={index}>{paragraph}</p>;
            })}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Privacy;
